// React
import { forwardRef, ReactNode } from "react"

// UI
import BrandLogo from "@/assets/icons/brand/zonhub_logo.svg?react"
import { cn } from "@/lib/utils"
import { Heading } from "@/components/Typography"

/**
 * PDFViewWrapper
 * Wrap anything you want to print inside this wrapper to apply brand styling
 * It creates a component thats visually outside of the view
 */
interface PDFViewWrapperProps {
	children: ReactNode
	title: string
	width: number
}
export const PDFViewWrapper = forwardRef<HTMLDivElement, PDFViewWrapperProps>(
	({ children, title, width }, ref) => (
		<div
			style={{
				position: "absolute",
				top: 0,
				left: `-${width}px`,
				width: `${width}px`,
			}}
		>
			<div ref={ref}>
				<div
					className={cn(
						"bg-primary-500 flex h-14 shrink-0 items-center shadow-[0px_1px_3px_rgba(0,0,0,0.25)] 2xl:h-16",
						"flex justify-end pl-2",
					)}
				>
					<div className="shrink">
						<BrandLogo className="h-full brightness-0 grayscale" />
					</div>
					<Heading
						as="h1"
						styleAs="h3"
						className="font-static ml-auto pr-2 text-lg font-extrabold uppercase"
					>
						{title}
					</Heading>
				</div>
				<div className="px-4 py-6">{children}</div>
			</div>
		</div>
	),
)
PDFViewWrapper.displayName = "PDFViewWrapper"
